<template>
    <v-dialog
        :model-value="modelValue"
        max-width="640"
        scrollable
        @update:model-value="$emit('update:modelValue', $event)"
    >
        <v-card rounded="lg" class="corporate-dialog">
            <v-card-title class="corporate-dialog__header">
                <div>
                    <h2 class="corporate-dialog__title">{{ title }}</h2>
                </div>
            </v-card-title>
            <v-card-text class="corporate-dialog__body">
                <section class="corporate-dialog__section">
                    <p class="corporate-dialog__section-label">{{ sectionDataLabel }}</p>
                    <div class="corporate-dialog__section-body">
                        <v-text-field
                            v-model="form.name"
                            :label="structureLabels.name"
                            variant="outlined"
                            density="compact"
                            class="weeduc-admin-v-field"
                            hide-details="auto"
                        />
                        <v-textarea
                            v-model="form.description"
                            :label="structureLabels.description"
                            variant="outlined"
                            density="compact"
                            rows="2"
                            class="weeduc-admin-v-field"
                            hide-details="auto"
                        />
                        <div class="corporate-dialog__row">
                            <v-select
                                v-model="form.sectorId"
                                :items="sectorOptions"
                                item-title="text"
                                item-value="value"
                                :label="labels.sector"
                                variant="outlined"
                                density="compact"
                                class="weeduc-admin-v-field"
                                hide-details="auto"
                            />
                            <v-select
                                v-model="form.status"
                                :items="statusOptions"
                                item-title="text"
                                item-value="value"
                                :label="structureLabels.status"
                                variant="outlined"
                                density="compact"
                                class="weeduc-admin-v-field"
                                hide-details="auto"
                            />
                        </div>
                        <v-select
                            v-model="form.courseIds"
                            :items="courseOptions"
                            item-title="text"
                            item-value="value"
                            :label="labels.mandatoryCourses"
                            variant="outlined"
                            density="compact"
                            multiple
                            chips
                            clearable
                            class="weeduc-admin-v-field"
                            hide-details="auto"
                        />
                        <v-select
                            v-model="form.managerUserId"
                            :items="managerOptions"
                            item-title="text"
                            item-value="value"
                            :label="structureLabels.manager"
                            variant="outlined"
                            density="compact"
                            clearable
                            class="weeduc-admin-v-field"
                            hide-details="auto"
                        />
                    </div>
                </section>
            </v-card-text>
            <v-card-actions class="corporate-dialog__actions">
                <v-spacer />
                <v-btn variant="text" class="text-none" @click="$emit('update:modelValue', false)">
                    {{ common.cancel }}
                </v-btn>
                <v-btn
                    color="primary"
                    variant="flat"
                    rounded="lg"
                    class="text-none"
                    :loading="saving"
                    @click="submit"
                >
                    {{ common.save }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { corporateI18n } from '@/i18n/mixins';

export default {
    name: 'RoleForm',
    mixins: [corporateI18n],
    props: {
        modelValue: Boolean,
        title: String,
        labels: Object,
        structureLabels: Object,
        common: Object,
        initial: {
            type: Object,
            default: () => ({}),
        },
        sectorOptions: {
            type: Array,
            default: () => [],
        },
        courseOptions: {
            type: Array,
            default: () => [],
        },
        managerOptions: {
            type: Array,
            default: () => [],
        },
        saving: Boolean,
    },
    emits: ['update:modelValue', 'submit'],
    data() {
        return {
            form: this.defaultForm(),
        };
    },
    computed: {
        statusOptions() {
            return [
                { text: this.structureLabels.active, value: 'active' },
                { text: this.structureLabels.inactive, value: 'inactive' },
            ];
        },
        sectionDataLabel() {
            return this.common?.sectionData || this.t.common.sectionData;
        },
    },
    watch: {
        modelValue(open) {
            if (open) {
                this.form = { ...this.defaultForm(), ...this.initial };
            }
        },
    },
    methods: {
        defaultForm() {
            return {
                id: null,
                name: '',
                description: '',
                sectorId: null,
                status: 'active',
                courseIds: [],
                managerUserId: null,
            };
        },
        submit() {
            if (!this.form.name?.trim() || !this.form.sectorId) return;
            this.$emit('submit', { ...this.form });
        },
    },
};
</script>

<style scoped>
@import '@/css/weeduc/admin/corporate.css';
</style>
